<div class="status-label {{cssClasses}}">
    <div *ngIf="icon" class="status-label__icon">
        <mat-icon class="material-icons-round">{{icon}}</mat-icon>
    </div>
    <span class="status-label__text">{{statusLabelText}}</span>
</div>
